import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { Field,Form } from 'react-final-form';
import { FormattedMessage, injectIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import {
  AppWrapper,
  AppWrapperHeading,
  Block,
  Button,
  FormField,
} from 'components';
import { AuthProtected, ChangePassword } from 'containers';
import { actions as membershipInfoActions } from 'coupon-common/src/modules/memberships/info';
import {
  composeSyncValidators,
  required,
  validEmail,
} from 'coupon-common/src/utils';

import messages from './messages';

const AccountSettings = ({ intl }) => {
  const dispatch = useDispatch();

  const businessInfo = useSelector(state => state.businessInfo.data);

  const membershipInfo = useSelector(state => state.memberships?.info);
  const currentPlan = membershipInfo?.data?.current_plan;
  const membershipFetching = !!membershipInfo?.fetching;

  const [changePassOpen, setChangePassOpen] = useState(false);
  const [cancelNote, setCancelNote] = useState('');

  useEffect(() => {
    dispatch(membershipInfoActions.getMembershipInfo());
  }, [dispatch]);

  const openChangePassModal = () => setChangePassOpen(true);
  const closeChangePassModal = () => setChangePassOpen(false);

  const planName = membershipFetching ? '...' : currentPlan?.name || 'Free';

  return (
    <Form
      onSubmit={() => {}}
      initialValues={businessInfo}
      render={({ handleSubmit }) => (
        <AppWrapper
          showHeader
          showSideNav
          showHeadingRow
          headingRowRender={() => (
            <div className="col-12 d-flex flex-column">
              <AppWrapperHeading
                headingText={intl.formatMessage(messages.headingText)}
              />
            </div>
          )}
        >
          <AuthProtected />

          <form onSubmit={handleSubmit} className="col-md-6">
            {/* Account */}
            <Block>
              <Field
                name="email"
                label={intl.formatMessage(messages.emailLabelText)}
                type="email"
                autoComplete="off"
                validate={composeSyncValidators(required, validEmail())}
                readOnly
                component={FormField}
              />

              <FormField
                name="password"
                label={intl.formatMessage(messages.passwordLabelText)}
                type="password"
                autoComplete="new-password"
                input={{ name: 'password', value: '************' }}
                readOnly
                meta={{}}
              />

              <div className="row justify-content-center mb-2">
                <Button
                  className="w-100"
                  outline
                  type="button"
                  onClick={openChangePassModal}
                >
                  <FormattedMessage {...messages.changePasswordButtonText} />
                </Button>
              </div>

              <ChangePassword
                isOpen={changePassOpen}
                onRequestClose={closeChangePassModal}
                onChangeSuccess={closeChangePassModal}
              />
            </Block>

            {/* Membership */}
            <Block>
              <h5 style={{ marginBottom: 8 }}>Membership</h5>

              <div className="d-flex justify-content-between align-items-center mb-2">
                <span className="text-muted" style={{ fontSize: 13 }}>
                  Current Plan
                </span>
                <strong style={{ fontSize: 13 }}>{planName}</strong>
              </div>

              <p className="text-muted" style={{ marginBottom: 12 }}>
                Cancel your membership and revert to a free account. Your
                published coupons may be affected based on plan limits.
              </p>

              <Button
                type="button"
                outline
                style={{
                  borderColor: '#dc3545',
                  color: '#dc3545',
                  width: '100%',
                }}
                onClick={() => {
                  setCancelNote('');
                  const ok = window.confirm(
                    'Are you sure you want to cancel your membership and revert to a free account?',
                  );
                  if (!ok) return;
                  // dispatchAsAsync(membershipActions.cancelMembership(), dispatch)
                  //   .then(() => dispatch(membershipInfoActions.getMembershipInfo()))
                  //   .catch(...)
                  setCancelNote('Cancel membership API not wired yet.');
                }}
              >
                Cancel Membership
              </Button>

              {cancelNote && (
                <div className="text-muted mt-2" style={{ fontSize: 12 }}>
                  {cancelNote}
                </div>
              )}
            </Block>
          </form>
        </AppWrapper>
      )}
    />
  );
};

AccountSettings.propTypes = {
  intl: PropTypes.object.isRequired,
};

export default injectIntl(AccountSettings);
